<p-calendar [defaultDate]="defaultDate"
            [style]="style"
            [styleClass]="styleClass"
            [inputStyle]="inputStyle"
            [inputId]="inputId"
            [name]="name"
            [inputStyleClass]="inputStyleClass"
            [placeholder]="placeholder"
            [disabled]="disabled"
            [minDate]="minJsDate"
            [maxDate]="maxJsDate"
            [dateFormat]="dateFormat"
            [inline]="inline"
            [showOtherMonths]="showOtherMonths"
            [selectOtherMonths]="selectOtherMonths"
            [showIcon]="showIcon"
            [icon]="icon"
            [appendTo]="appendTo"
            [readonlyInput]="readonlyInput"
            [shortYearCutoff]="shortYearCutoff"
            [monthNavigator]="monthNavigator"
            [yearNavigator]="yearNavigator"
            [yearRange]="yearRange"
            [hourFormat]="hourFormat"
            [showTime]="showTime"
            [timeOnly]="timeOnly"
            [stepHour]="stepHour"
            [stepMinute]="stepMinute"
            [stepSecond]="stepSecond"
            [showSeconds]="showSeconds"
            [required]="required"
            [showOnFocus]="showOnFocus"
            [dataType]="dataType"
            [selectionMode]="selectionMode"
            [maxDateCount]="maxDateCount"
            [showButtonBar]="showButtonBar"
            [todayButtonStyleClass]="todayButtonStyleClass"
            [clearButtonStyleClass]="clearButtonStyleClass"
            [autoZIndex]="autoZIndex"
            [baseZIndex]="baseZIndex"
            [ngModel]="value"
            (ngModelChange)="valueChanged($event)"
            (onBlur)="blurEvent($event)"
            (onFocus)="onFocus.emit($event)"
            (onClose)="onClose.emit($event)"
            (onSelect)="onSelect.emit($event)"
            (onInput)="onInput.emit($event)"
            (onTodayClick)="onTodayClick.emit($event)"
            (onClearClick)="onClearClick.emit($event)"
            (onMonthChange)="onMonthChange.emit($event)">
</p-calendar>